import type { LegendItem } from 'chart.js';
import React from 'react';
import styles from './base-chart-legend.module.scss';
import { colors } from '@utils/colors';

export const BaseChartLegend: React.FC<{ items: LegendItem[] }> = ({ items }) => (
  <ul className={styles.list}>
    {items.map(item => (
      <li className={styles.listItem} key={item.text}>
        <span
          className={styles.listItemColorBox}
          style={{
            backgroundColor: typeof item.fillStyle === 'string' ? item.fillStyle : colors.highlight
          }}
        ></span>
        {item.text}
      </li>
    ))}
  </ul>
);
